import {__} from "./__";

export const getTutorialSteps = () => {
    return {
        1: { name: __('Aktivácia eshopu'), redirect: '/eshop' },
        2: { name: __('Nastavenia eshopu'), redirect: '/eshop' },
        3: { name: __('Aktivácia ekonomického systému'), redirect: '/accounting' },
        4: { name: __('Aktivácia prepravcov'), redirect: '/couriers' },
    };
};
